export const componentMap = {
  cephCSI: 'Ceph',
  fluentbit: 'Fluentbit',
  monitor: 'Monitor',
}
